import deepmerge from 'deepmerge';
import { fade } from '@/uptk/core/packages/style/color_utils';

export const defaultStatus = {
  error: {
    icon: 'error'
  },
  info: {
    icon: 'info'
  },
  success: {
    icon: 'tick'
  },
  warning: {
    icon: 'warning'
  },
};

const createErrorPalette = ({
  type,
  red20,
  red500,
  white
}: any) => {
  if (type == 'light') {
    return {
        ...defaultStatus.error,
      color1: red20,
      color2: red500,
      color3: white
    };
  }
  return {
    ...defaultStatus.error,
    color1: fade(red500, 0.15),
    color2: red500,
    color3: white
  }
};

const createInfoPalette = ({
  type,
  blue20,
  blue500,
  white
}: any) => {
  if (type == 'light') {
    return {
        ...defaultStatus.info,
      color1: blue20,
      color2: blue500,
      color3: white
    };
  }
  return {
    ...defaultStatus.info,
    color1: fade(blue500, 0.15),
    color2: blue500,
    color3: white
  }
};

const createSuccessPalette = ({
  type,
  orange20,
  orange500,
  white
}: any) => {
  if (type == 'light') {
    return {
        ...defaultStatus.success,
      color1: orange20,
      color2: orange500,
      color3: white
    };
  }
  return {
    ...defaultStatus.success,
    color1: fade(orange500, 0.15),
    color2: orange500,
    color3: white
  }
};

const createWarningPalette = ({
  type,
  green20,
  green500,
  white
}: any) => {
  if (type == 'light') {
    return {
        ...defaultStatus.warning,
      color1: green20,
      color2: green500,
      color3: white
    };
  }
  return {
    ...defaultStatus.warning,
    color1: fade(green500, 0.15),
    color2: green500,
    color3: white
  }
};

const createEmphasis = ({
  color1,
  color2,
  color3,
  ...rest
}: any) => ({
  low: {
    background: color3,
    borderColor: color2,
    iconColor: color2,
    ...rest
  },
  medium: {
    background: color1,
    borderColor: color2,
    iconColor: color2,
    ...rest
  },
  high: {
    background: color2,
    borderColor: color2,
    iconColor: color2,
    ...rest
  }
});

const createOptions = (palette: any) => {
  const errorPalette = createErrorPalette(palette);
  const infoPalette = createInfoPalette(palette);
  const successPalette = createSuccessPalette(palette);
  const warningPalette = createWarningPalette(palette);
  return {
    info: createEmphasis(infoPalette),
    error: createEmphasis(errorPalette),
    warning: createEmphasis(warningPalette),
    success: createEmphasis(successPalette)
  };
};

const createGetStatus = (options: any) => ({
  status: statusProp,
  emphasis
}: any = {}) => {
  const { hasOwnProperty } = Object.prototype;
  if (!hasOwnProperty.call(options, statusProp)) {
    return {};
  }
  const allEmphasis = options[statusProp];
  if (hasOwnProperty.call(allEmphasis, emphasis)) {
    return allEmphasis[emphasis];
  }
  return options[statusProp];
};

export const createStatus = (palette: any, status = {}) => {
  const { getStatus: otherGetStatus, ...otherOptions }
  = typeof status == 'function' ? status(palette) : status;
  const options = createOptions(palette);
  const mergedOptions = deepmerge(options, otherOptions, {
    clone: false
  });
  return {
    getStatus: otherGetStatus || createGetStatus(mergedOptions),
      ...mergedOptions
  };
};
